import { render } from "./Option.vue?vue&type=template&id=e8929a4c"
import script from "./Option.vue?vue&type=script&lang=js"
export * from "./Option.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/ab-front-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__